export default class Clerk {
    constructor(client) {
        this.client = client
    }

    async request(method, endpoint, params) {
        return await this.client.request({
            method: method,
            url: "/clerk/" + endpoint,
            ...params
        })
    } 

    async prompt(text, config) {
        return await this.request("POST", "prompt", {
            data: {
                text,
                config
            },

            timeoutout : 60000 * 2,
        })
    }

    async processDocument(processor, location, files) {
        return await this.request("POST", "document/process", {
            data: {
                processorId: processor,
                location,
                files,
            },

            timeoutout : 60000 * 2,
        })
    }
}